import { createIcon } from "@chakra-ui/icons";

// Created from no-files.svg

export const NoFilesIcon = createIcon({
  displayName: "NoFiles",
  viewBox: "0 0 48 55",
  path: (
    <path
      d="M42.5 45H15C13.625 45 12.4479 44.5104 11.4688 43.5313C10.4896 42.5521 10 41.375 10 40V5C10 3.625 10.4896 2.44792 11.4688 1.46875C12.4479 0.489583 13.625 0 15 0H32.5L47.5 15V40C47.5 41.375 47.0104 42.5521 46.0313 43.5313C45.0521 44.5104 43.875 45 42.5 45ZM30 17.5V5H15V40H42.5V17.5H30ZM5 55C3.625 55 2.44792 54.5104 1.46875 53.5313C0.489583 52.5521 0 51.375 0 50V15H5V50H32.5V55H5Z"
      fill="currentColor"
    />
  ),
});
